export default "__VITE_ASSET__CqIBujf7__"